module.exports = __webpack_public_path__ + "img/2-5.6e0dfdb5.svg";